import { useEffect, useState } from "react";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
} from "@mui/material";
import cardValidator from "card-validator";

const CARD_TYPE = {
  '4': { name: 'Tarjeta Naranja Crédito', type: 'credit' },
  '26': { name: 'CABAL Crédito', type: 'credit' },
  '33': { name: 'CABAL Débito', type: 'debit' }
}

export const NumberCard = ({
  handleChange,
  values,
  setInvalidState,
  setProveedor,
}: any) => {
  const [validNumber, setValidNumber] = useState({ provider: "CARD", state: false, type: '' });
  const [typeCard, setTypeCard] = useState<string>('')// 1 credito / 2 debito

  useEffect(() => {

    const validateNumberCard = (number: any) => {
      const cardResult = cardValidator.number(number);

      if (cardResult.isValid && cardResult.card) {
        let typeCardProvider = '';
        setProveedor(cardResult.card.niceType)
        setValidNumber({ state: cardResult.isValid, provider: cardResult.card.niceType, type: cardResult.card.type });

        if (typeCard === '1') {
          handleChange("cardType")({ target: { value: 'credit' } });
          switch (cardResult.card.type) {
            case 'visa':
              typeCardProvider = '1';
              break;
            case 'american-express':
              typeCardProvider = '34';
              break;
            case 'mastercard':
              typeCardProvider = '29';
              break;
            case 'maestro':
              typeCardProvider = '32';
              break;
            case 'cabal':
              typeCardProvider = '26';
              break;
            default:
              break;
          }

        } else if (typeCard === '2') {
          handleChange("cardType")({ target: { value: 'debit' } });
          switch (cardResult.card.type) {
            case 'visa':
              typeCardProvider = '30';
              break;
            case 'mastercard':
              typeCardProvider = '31';
              break;
            case 'cabal':
              typeCardProvider = '33';
              break;
            default:
              break;
          }

        } else if (typeCard === '4'|| typeCard === '33' || typeCard === '26') {
          typeCardProvider = typeCard;
          setValidNumber({ state: true, provider: CARD_TYPE[typeCard].name, type: CARD_TYPE[typeCard].name });
          handleChange("cardType")({ target: { value: CARD_TYPE[typeCard].type } });
        }

        handleChange("cardIdentification")({ target: { value: typeCardProvider } });

      } else {
        setValidNumber({ state: false, provider: "CARD", type: '' });
      }
      setInvalidState(validNumber.state);
    };

    validateNumberCard(values.numberCard);
  }, [values.numberCard, typeCard]);

  const handleChangeSelect = (event: SelectChangeEvent) => {
    setTypeCard(event?.target?.value);
  };

  useEffect(() => {
    setInvalidState(!validNumber.state || !typeCard);
    setProveedor(validNumber.provider);
  }, [validNumber, setInvalidState, setProveedor]);

  return (
    <Box component="form" noValidate sx={{ mt: 5 }}>
      <FormControl fullWidth error={!typeCard}>
        <InputLabel id="demo-simple-select-label">Tipo</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={typeCard}
          label="Tarjeta"
          onChange={handleChangeSelect}
        >
          <MenuItem style={{ color: "black" }} value={'1'}>
            Crédito
          </MenuItem>
          <MenuItem style={{ color: "black" }} value={'2'}>
            Débito
          </MenuItem>
          <MenuItem style={{ color: "black" }} value={'4'}>
            Tarjeta Naranja Crédito
          </MenuItem>
          <MenuItem style={{ color: "black" }} value={'26'}>
            CABAL Crédito
          </MenuItem>
          <MenuItem style={{ color: "black" }} value={'33'}>
            CABAL Débito
          </MenuItem>

        </Select>
      </FormControl>

      <TextField
        margin="normal"
        required
        fullWidth
        id="numberCard"
        label="Número tarjeta"
        name="numberCard"
        inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
        type="number"
        value={values.numberCard}
        onChange={handleChange("numberCard")}
        error={!validNumber.state}
      />
    </Box>
  );
};
